import { gql } from 'apollo-boost';

export const create = gql`
  mutation create($ePro: EProCreateInput!) {
    ePro {
      create(ePro: $ePro) {
        id
      }
    }
  }
`;

export const update = gql`
  mutation update($ePro: EProUpdateInput!) {
    ePro {
      update(ePro: $ePro) {
        id
      }
    }
  }
`;

export const deleteItem = gql`
  mutation deleteItem($eProId: Int!) {
    ePro {
      delete(eProId: $eProId)
    }
  }
`;
